/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import RETAIL from '../BaseComponent/RETAIL'
import Sort from '../Pagination/Sort'
import {voip} from '../Reports/call/voip'
import {message} from 'antd'
import {editOrder} from '../../lib/path'

class DeliveryPackComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      urlSign: '',
      deliveryPackData: [],
      colored: [],
      sortData: [
        {
          name: 'ردیف',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: this.props.subDispatch ? 'تاریخ توزیع' : 'تاریخ تحویل',
          value: this.props.subDispatch ? 'dispatchPlanDate' : 'planDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: this.props.subDispatch ? 'بازه توزیع' : 'بازه تحویل',
          value: this.props.subDispatch ? 'dispatchPlanTimeFrom' : 'planTimeFrom',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان تحویل',
          value: 'dispatchDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره فاکتور',
          value: 'invoiceNum',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'خریدار',
          value: 'buyerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد مشتری',
          value: 'userCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تحویل گیرنده',
          value: 'recipientName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'آدرس',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'وضعیت پرداخت',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پرداخت در محل',
          value: 'confirmDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'رساننده',
          value: 'driverName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد اتومبیل',
          value: 'carCode',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'قابل پرداخت',
          value: 'payableAmount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پرداخت نقدی',
          value: 'payableAmount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پرداخت کارتخوان',
          value: 'payableAmount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پرداخت از قبل',
          value: 'payableAmount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حالت',
          value: 'lastState',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نوع تحویل',
          value: 'lastState',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'جزییات',
          value: 'lastState',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پرداختی',
          value: 'lastState',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'lastState',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }
  componentDidMount() {
    this.setState({
      deliveryPackData: this.props.deliveryPackData
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.deliveryPackData !== this.props.deliveryPackData) {
      let deliveryPackData = this.props.deliveryPackData
      let colored = this.state.colored
      for (let i in colored) {
        let findIndex = deliveryPackData.findIndex((items) => items.invoice.invoiceId === colored[i])
        if (findIndex >= 0) {
          deliveryPackData[findIndex].colored = true
        }
      }
      this.setState({
        deliveryPackData
      })
    }
  }

  convertState = (x, y) => {
    if (x == -100) {
      x = 'کنسل'
      // return x;
    } else if (x == -75) {
      x = 'مرجوعی'
      // return x;
    } else if (x == -50) {
      x = 'بازگشتی'
      // return x;
    } else if (x == 100) {
      x = 'تخصیص مجدد'
      // return x;
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      // return x;
    } else if (x === 1) {
      x = 'فعال'
      // return x;
    } else if (x == 5) {
      x = 'اول فعال'
      // return x;
    } else if (x == 15) {
      x = 'تحویل ناقص'
      // return x;
    } else if (x == 10) {
      x = 'شروع شده'
      // return x;
    } else if (x == 18) {
      x = 'تسویه نشده'
      // return x;
    } else if (x == 20) {
      x = 'تسویه شده'
    }

    if (y) {
      y = 'تخصیص مجدد'
    } else {
      y = ''
    }

    return y == '' ? x : y + ' - ' + x
  }

  openSign = (num) => {
    sessionStorage.setItem('index', num)
    this.setState({
      modal: !this.state.modal
    })
    let {deliveryPackData} = this.props

    var deliveryPackId = deliveryPackData[num].deliveryPackId
    let data = {
      deliveryPackId: deliveryPackId
    }
    http
      .post(`${RETAIL.RETAIL_COMPANY_DELIVERYPACK_SIGN}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            urlSign: `data:image/png;base64,${response.data.object}`
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleCancel = (e) => {
    sessionStorage.removeItem('index')

    this.setState({
      modal: !this.state.modal
    })
  }
  goBeroozresan = (invoiceId) => {
    window.open(editOrder({invoiceId}), '_blank')
    let colored = this.state.colored
    colored.push(invoiceId)
    this.setState({
      colored
    })
    let findRow = this.state.deliveryPackData.findIndex((items) => items.invoice.invoiceId === invoiceId)
    let deliveryPackData = this.state.deliveryPackData
    deliveryPackData[findRow].colored = true
    this.setState({
      deliveryPackData
    })
  }

  getSort = (sortBy) => {
    this.props.getDeliverySort(sortBy)
  }

  callToCustomer = (mobile, buyerName) => {
    if (mobile === '') {
      message.error('شماره موبایل مورد نظر وجود ندارد')
    } else {
      this.setState({
        showMobileCallModal: true
      })
      let internalPhone = '725'
      voip(mobile, buyerName)
        .then((res) => {
          if (res) {
            message.success('تماس برقرار شد لطفا منتظر پاسخ بمانید')
          } else {
            console.log('error')
            this.setState({
              showMobileCallModal: false
            })
          }
        })
        .catch((err) => {
          message.error(err)
          this.setState({
            showMobileCallModal: false
          })
        })
    }
  }

  getDeliveryType = (items, index) => {
    if (items.hasSign) {
      return (
        <button onClick={() => this.openSign(index)} style={{background: '#d8d8d8', borderRadius: '3px'}}>
          امضا
        </button>
      )
      // return ''
    } else {
      if (items.deliveryCode === null) {
        return ' - '
      } else if (items.deliveryCode === true) {
        return ' کد مشتری'
      } else if (items.deliveryCode === false) {
        return ' کد پشتیبان'
      }
    }
  }

  render() {
    let {deliveryPackData, pageNumber, pageSize, disableSort} = this.props
    let {urlSign} = this.state
    return (
      <div className="showBaseTable print">
        <table className="baseTable">
          {!disableSort && <Sort data={this.state.sortData} getSort={this.getSort} />}

          <tbody>
            {disableSort && (
              <tr className="firstRow">
                <td>ردیف</td>
                <td>{this.props.subDispatch ? 'تاریخ توزیع' : 'تاریخ تحویل'}</td>
                <td>{this.props.subDispatch ? 'بازه توزیع' : 'بازه تحویل'}</td>
                <td>زمان تحویل</td>
                <td>شناسه فاکتور</td>
                <td>شماره فاکتور</td>
                <td> خریدار</td>
                <td>کد مشتری</td>
                <td> تحویل گیرنده</td>
                <td>آدرس</td>
                <td>موبایل</td>
                <td>وضعیت پرداخت</td>
                <td>پرداخت در محل</td>
                <td>رساننده</td>
                <td>کد اتومبیل</td>
                <td className="priceCell">قابل پرداخت</td>
                <td className="priceCell">پرداخت نقدی</td>
                <td className="priceCell">پرداخت کارتخوان</td>
                <td className="priceCell">پرداخت از قبل</td>
                <td>حالت</td>
                <td>نوع تحویل</td>
                <td>جزییات</td>
                <td>پرداختی</td>
                <td>ویرایش</td>
              </tr>
            )}

            {this.state.deliveryPackData.map((items, index) => (
              <tr key={index} style={items.colored ? {background: 'rgba(255,196,25,0.53)'} : {background: ''}}>
                <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                <td>
                  {this.props.subDispatch
                    ? jMoment(items.dispatchPlanDate).format('jYYYY/jM/jD')
                    : jMoment(items.planDate).format('jYYYY/jM/jD')}
                </td>
                <td>
                  {this.props.subDispatch
                    ? items.dispatchPlanTimeFrom.substr(0, 5) + ' - ' + items.dispatchPlanTimeTo.substr(0, 5)
                    : items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}
                </td>
                <td>{items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}</td>
                <td>{items.invoice.invoiceId}</td>
                <td>{items.invoice.invoiceNum}</td>
                <td>{items.invoice.buyerName}</td>

                <td>
                  <Link target="_blank" to={`/base/users/persina/${items.customer.userCode}`}>
                    {items.customer.userCode}
                  </Link>
                </td>

                <td>{items.invoice.recipientName}</td>
                <td>{items.invoice.address}</td>
                <td className="">
                  <button
                    title="تماس"
                    className="btn btn-sm btn-success text-dark font-weight-bold"
                    onClick={() =>
                      this.callToCustomer(
                        items.invoice.mobile == null ? '' : items.invoice.mobile.replace(/\+98/g, '0'),
                        items.invoice.buyerName
                      )
                    }
                  >
                    <span className="text-dark font-weight-bold" style={{color: '#000'}}>
                      {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                    </span>
                  </button>
                </td>
                <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                <td title={items.driver == null ? '-' : items.driver.mobile.replace(/\+98/g, '0')}>
                  {items.driver == null ? '-' : items.driver.name}
                </td>
                <td>{items.car == null ? '-' : items.car.code}</td>
                <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(items.payment.cash, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(items.payment.card, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(items.payment.prePaid, '', ',')}</td>
                <td>{this.convertState(items.lastState, items.reAssigned)}</td>

                <td>
                  <div>{this.getDeliveryType(items, index)}</div>
                </td>

                <td>
                  {this.props.subDispatch ? (
                    <Link
                      to={`/itemDispatch/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                        items.invoice.invoiceId
                      }/${items.invoice.buyerName}`}
                      target="_blank"
                    >
                      <img src={require('../../image/details.svg')} alt="" />
                    </Link>
                  ) : (
                    <Link
                      to={`/itemBascket/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                        items.invoice.invoiceId
                      }/${items.invoice.buyerName}`}
                      target="_blank"
                    >
                      <img src={require('../../image/details.svg')} alt="" />
                    </Link>
                  )}
                </td>
                <td>
                  <Link
                    to={`/detailsPaid/${items.detailId}/${items.invoice.invoiceId}/${
                      items.driver == null ? '-' : items.driver.name
                    }/${items.driver == null ? '-' : items.driver.personId}`}
                    target="_blank"
                  >
                    <img
                      style={
                        items.detailId == null
                          ? {display: 'none'}
                          : {
                              display: 'block',
                              margin: 'auto'
                            }
                      }
                      src={require('../../image/details.svg')}
                      alt=""
                    />
                  </Link>
                </td>
                <td>
                  <button onClick={() => this.goBeroozresan(items.invoice.invoiceId)}>
                    <img src={require('../../image/eye.svg')} />
                  </button>
                </td>
              </tr>
            ))}
            {/*<tr>*/}
            {/*    <td colSpan={15}>مجموع</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.totalInfo ? aggregation.totalInfo.payableAmount : '','',',')}</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.payment? aggregation.payment.cash : '','',',')}</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.payment? aggregation.payment.card : '','',',')}</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.payment? aggregation.payment.prePaid : '','',',')}</td>*/}
            {/*    <td className='priceCell' colSpan={5}></td>*/}
            {/*</tr>*/}
          </tbody>
        </table>
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="sm">
          <ModalHeader toggle={this.toggle}>نمایش امضا</ModalHeader>
          <ModalBody>
            <div className="imageSign">
              <img src={urlSign} alt="" />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.handleCancel}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.showMobileCallModal} toggle={() => this.setState({showMobileCallModal: false})}>
          <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
            <h3 className="font-weight-bold">تماس با کاربر برقرار شد</h3>
            <button className="btn btn-success" onClick={() => this.setState({showMobileCallModal: false})}>
              بستن
            </button>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
export default DeliveryPackComponent
